export const LEGAL_AFFILIATE_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Affiliate-Bedingungen</h1>
 Allgemeine Geschäftsbedingungen im Überblick
</center>

---

## Affiliate-Bedingungen

*Gültig ab dem 19. November 2024*
`;
